import { render } from "./FeaturedPatternComponent.vue?vue&type=template&id=282d9e6b&scoped=true"
import script from "./FeaturedPatternComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedPatternComponent.vue?vue&type=script&lang=js"

import "./FeaturedPatternComponent.vue?vue&type=style&index=0&id=282d9e6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282d9e6b"]])

export default __exports__